<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>统计管理</el-breadcrumb-item>
        <el-breadcrumb-item>统计报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="供应总计" name="baseTotalStatistics">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="listForm" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="16">
                        <el-form-item label="日期查询：">
                          <date-picker-group v-model="timeInterval"></date-picker-group>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTotalTableData('baseTotalStatistics')"> 查询 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>

                <div>
                  <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel('/statistic/supply/goodsInfo/export')"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ tableTotalData.length }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" :data="tableTotalData" max-height="800" border>
                      <el-table-column prop="supplyCentre" align="center" label="供应单位"> </el-table-column>

                      <el-table-column width="100" prop="guaranteeCount" align="center" label="保障人数"> </el-table-column>

                      <el-table-column align="center" v-for="(item, index1) in columnTotalList" :key="index1" :label="item.title">
                        <el-table-column width="120" align="center" v-for="(item2, index2) in item.secondTitle" :key="index2" :label="item2">
                          <template slot-scope="scope">
                            {{ scope.row.goodsList[index1][index2] }}
                          </template>
                        </el-table-column>
                      </el-table-column>

                      <el-table-column align="center" prop="saleAmount" label="预定总金额" fixed="right">
                        <template slot-scope="scope"> ￥{{ scope.row.saleAmount ? scope.row.saleAmount.toFixed(2) : 0 }} </template>
                      </el-table-column>
                      <el-table-column align="center" prop="saleAmount" label="销售总金额" fixed="right">
                        <template slot-scope="scope"> ￥{{ scope.row.amountTotal ? scope.row.amountTotal.toFixed(2) : 0 }} </template>
                      </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="供应点总计" name="supplyCentreDetailStatistics">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="listForm" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="8">
                        <el-form-item label="供应点：">
                          <el-select size="small" v-model="siteId" style="width: 100%">
                            <el-option v-for="item in supplyCentreList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTableData('supplyCentreDetailStatistics')"> 查询 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>

                <div>
                  <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel('/statistic/site/goodsInfo/export')"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ tableData.length }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" :span-method="rowSpanCombine" max-height="800" :data="tableData" border>
                      <el-table-column v-for="(item, index) in columnList" :key="index" :label="item" align="center">
                        <template slot-scope="scope">
                          {{ scope.row[index] }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="基地总计" name="baseDetailStatistics">
          <el-row :gutter="24">
            <el-col :span="24">
              <div style="width: 95%" class="mg-auto mgt10">
                <div class="hx-form-container box-shadow">
                  <el-form ref="listForm" label-width="100px">
                    <el-row :gutter="24">
                      <el-col :span="16">
                        <el-form-item label="日期查询：">
                          <date-picker-group v-model="timeInterval"></date-picker-group>
                        </el-form-item>
                      </el-col>

                      <el-col :span="8">
                        <el-form-item>
                          <el-button size="small" type="primary" @click="loadTableData('baseDetailStatistics')"> 查询 </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>

                <div>
                  <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
                    <div slot="action"></div>

                    <hx-table-result-col>
                      <div class="wrap-table-info-display">
                        <el-button class="align-left" type="primary" size="small" @click="exportExcel('/statistic/baseSupplySituation/export')"> 导出 </el-button>
                        <span class="table-info-display">
                          <span>总条数：</span>
                          <span class="alert-text ft16">{{ tableData.length }}</span>
                        </span>
                      </div>
                    </hx-table-result-col>

                    <el-table stripe slot="content" max-height="800" :span-method="rowSpanCombine" :data="tableData" border>
                      <el-table-column v-for="(item, index) in columnList" :key="index" :label="item" align="center">
                        <template slot-scope="scope">
                          {{ scope.row[index] }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </hx-table-result>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { download } from "../../../../../utils/javascript/download";

export default {
  data() {
    return {
      siteId: "",
      timeInterval: [new Date().getTime() - 31 * 24 * 60 * 60 * 1000, Date.parse(new Date())],
      url: "",
      bodyParams: {},
      supplyId: "",
      supplyCentreList: [],
      activeName: "baseTotalStatistics",
      tableTotalData: [],
      tableData: [],
      tableLoading: false,
      columnList: [],
      columnTotalList: [],
      spanArr: [],
      spanIndex: 0,
    };
  },
  mounted() {
    this.switchTab(this.activeName);
    this.supplyId = this.$route.params.supplyId;
    this.loadSupplyCentreList();
  },
  methods: {
    /**
     * 初始化供应点列表
     */
    loadSupplyCentreList() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        methods: "GET",
        params: {
          supplyId: this.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.supplyCentreList = res.body.data.dataList;
              if (this.supplyCentreList) {
                this.siteId = this.supplyCentreList[0].id;
              }
            } else {
              this.supplyCentreList = [];
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载供应总计列表
     */
    loadTotalTableData() {
      this.tableLoading = true;
      this.bodyParams = {
        startTime: this.timeInterval[0],
        endTime: this.timeInterval[1],
      };
      this.$http({
        url: global.apiUrl + this.url,
        method: "GET",
        params: this.bodyParams,
      })
        .then(res => {
          this.tableLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.columnTotalList = res.body.data.columnList;
            this.tableTotalData = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 加载table列表
     * @param name
     */
    loadTableData(name) {
      this.spanArr = [];
      this.spanIndex = 0;
      this.tableLoading = true;
      switch (name) {
        case "supplyCentreDetailStatistics":
          this.bodyParams = Object.assign(
            {},
            {
              siteId: this.siteId,
            }
          );
          break;
        case "baseDetailStatistics":
          this.bodyParams = Object.assign(
            {},
            {
              startTime: this.timeInterval[0],
              endTime: this.timeInterval[1],
            }
          );
          break;
      }
      if (this.url !== "") {
        this.$http({
          url: global.apiUrl + this.url,
          method: "GET",
          params: this.bodyParams,
        })
          .then(res => {
            this.tableLoading = false;
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              let tableData = [];
              let data = [];
              let total = 0;
              switch (name) {
                case "supplyCentreDetailStatistics":
                  this.columnList = res.body.data.columns;
                  tableData = res.body.data.content;
                  let sumIndex = 0;
                  tableData.map((item, index) => {
                    Object.assign(item, {
                      stockNumber: item.stockNumber,
                      saleNumber: item.saleNumber,
                      saleAmount: item.saleAmount,
                    });
                    item.items.map((item1, index1) => {
                      item1.unshift(item.categoryName);
                    });
                    total += item.items.length;
                    data = data.concat(item.items);
                    sumIndex += item.items.length + 1;
                    data.splice(sumIndex, 0, ["合计", "", "", "", "", "", item.stockNumber, item.saleNumber, item.saleAmount]);
                  });
                  break;
                case "baseDetailStatistics":
                  this.columnList = res.body.data.columns;
                  tableData = res.body.data.content;
                  tableData.map((item, index) => {
                    item.items.map((item1, index1) => {
                      item1.unshift(item.baseName);
                    });
                    total += item.items.length;
                    data = data.concat(item.items);
                  });
                  break;
              }
              // 合并行处理
              data.map((item, index) => {
                if (index === 0) {
                  this.spanArr.push(1);
                  this.spanIndex = 0;
                } else {
                  if (data[index][0] === data[index - 1][0]) {
                    this.spanArr[this.spanIndex] += 1;
                    this.spanArr.push(0);
                  } else {
                    this.spanArr.push(1);
                    this.spanIndex = index;
                  }
                }
              });
              this.tableData = data;
            } else {
            }
          })
          .catch(err => {
            this.tableLoading = false;

            console.error(err);
          });
      } else {
        this.tableLoading = false;
      }
    },
    /**
     * tab switch事件
     * @param tab
     * @param e
     */
    handleClick(tab, e) {
      this.switchTab(this.activeName);
    },
    switchTab(activeName) {
      this.tableData = [];
      switch (activeName) {
        case "baseTotalStatistics":
          this.url = "/statistic/supply/goodsInfo";
          setTimeout(() => {
            this.loadTotalTableData();
          }, 500);
          break;
        case "supplyCentreDetailStatistics":
          this.url = "/statistic/site/goodsInfo";
          setTimeout(() => {
            this.loadTableData("supplyCentreDetailStatistics");
          }, 500);
          break;
        case "baseDetailStatistics":
          this.url = "/statistic/baseSupplySituation";
          setTimeout(() => {
            this.loadTableData("baseDetailStatistics");
          }, 500);
          break;
      }
    },
    /**
     * 导出Excel表
     * @param url
     */
    exportExcel(url) {
      const bodyParams = Object.assign(this.bodyParams, {
        supplyId: this.supplyId,
      });

      download(url, bodyParams, "统计报表");

      // this.$router.open({
      //   path: url,
      //   query: bodyParams,
      //   type: "excel"
      // });
    },
    /**
     * 合并行
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     */
    rowSpanCombine({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="less">
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
